import { render, staticRenderFns } from "./Page_SingleMemberBiz.vue?vue&type=template&id=cb23d03e&scoped=true&"
import script from "./Page_SingleMemberBiz.vue?vue&type=script&lang=js&"
export * from "./Page_SingleMemberBiz.vue?vue&type=script&lang=js&"
import style0 from "./Page_SingleMemberBiz.vue?vue&type=style&index=0&id=cb23d03e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb23d03e",
  null
  
)

export default component.exports